import { useTranslation } from "react-i18next";
import type { QuestionData } from "../../models/GetQuestions";
import stackStyles from "../QuestionTypeStack.module.scss";
import { SingleSelectionWeb } from "./SingleSelectionWeb";

const getCorrectPositions = (
  correct_answer: (number | string | null)[][],
): number[] => {
  const first = correct_answer?.[0];
  if (first == null) return [];
  const val = Array.isArray(first) ? first[0] : first;
  if (val == null) return [];
  const num = Number(val);
  return isNaN(num) ? [] : [num];
};

type Props = {
  questionData: QuestionData;
  selectedValue: string;
  setSelectedValue: (val: string) => void;
};

export const SingleQuestionTypeScreen = ({
  questionData,
  selectedValue,
  setSelectedValue,
}: Props) => {
  const { t } = useTranslation("selflearn");
  const correctPositions = getCorrectPositions(
    questionData.question?.correct_answer ?? [],
  );

  return (
    <div
      className={stackStyles.stack}
      role="radiogroup"
      aria-label={t("reviseQuestions.a11y.answerChoices")}
    >
      {questionData.question?.answer_options?.map((option, index) => {
        const val = String(index + 1);
        return (
          <SingleSelectionWeb
            key={val}
            content={option as unknown as string}
            isSelected={selectedValue === val}
            onPress={() => setSelectedValue(val)}
            questionData={questionData}
            optionIndex={index}
            correctPositions={correctPositions}
          />
        );
      })}
    </div>
  );
};
